/*
 * Scrollytelling épinglé « Nos expertises ».
 *
 * L'épinglage est assuré par le CSS (.pinned = 500vh, .pinned-stage = position:
 * sticky / 100vh). Ce module ne fait QUE basculer la classe .active sur le panneau
 * correspondant à la progression du scroll dans la section .pinned. Le CSS gère
 * l'apparition (opacity/zoom) du panneau actif.
 *
 * Désactivé < 1024px et en prefers-reduced-motion : le CSS empile alors les panneaux
 * (tous visibles), on ne force aucun index.
 *
 * NB : le fonctionnement du sticky dépend du fix `:root { overflow-x: clip }` posé
 * dans home.scss (sans lui, l'ancêtre `html { overflow-x: hidden }` d'Alpha empêchait
 * l'épinglage → seul le 1er panneau s'affichait).
 */

// Mêmes seuils que le fallback CSS (@media max-width: 992px) + prefers-reduced-motion :
// sous 992px ou en reduced-motion, les panneaux sont empilés → pas de pilotage JS.
const fallbackMq = window.matchMedia('(max-width: 992px)')
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

function setupPinnedExpertises(section) {
  const panels = Array.from(section.querySelectorAll('.pinned-panel'))
  if (panels.length === 0) {
    return
  }

  let activeIndex = -1
  let ticking = false

  function setActive(index) {
    if (index === activeIndex) {
      return
    }
    activeIndex = index
    panels.forEach((panel, i) => panel.classList.toggle('active', i === index))
  }

  function update() {
    ticking = false

    // Fallback (mobile / reduced-motion) : le CSS empile et affiche tous les
    // panneaux ; on n'impose aucun index.
    if (fallbackMq.matches || reduceMotion.matches) {
      if (activeIndex !== -1) {
        activeIndex = -1
        panels.forEach((panel) => panel.classList.remove('active'))
      }
      return
    }

    // progress 0→1 sur toute la plage d'épinglage (hauteur section − hauteur viewport).
    const pinDistance = section.offsetHeight - window.innerHeight
    const scrolled = -section.getBoundingClientRect().top
    const progress = pinDistance > 0 ? Math.max(0, Math.min(1, scrolled / pinDistance)) : 0
    setActive(Math.min(panels.length - 1, Math.floor(progress * panels.length)))
  }

  function onScroll() {
    if (!ticking) {
      ticking = true
      window.requestAnimationFrame(update)
    }
  }

  window.addEventListener('scroll', onScroll, {
    passive: true
  })
  window.addEventListener('resize', onScroll)
  update()
}

function init() {
  document.querySelectorAll('.pinned').forEach(setupPinnedExpertises)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
